import { useQuery } from '@tanstack/react-query';
import { walletService } from '../services/wallet.service';

export const WALLET_STATE_KEY = ['seller', 'wallet-state'];

export function useWalletState() {
  return useQuery({
    queryKey: WALLET_STATE_KEY,
    queryFn: () => walletService.getWalletState(),
  });
}
